'use client';

import { useAdManager } from '#/hooks/useAdManager';

type Props = {
  noAds: boolean;
};

export function LayoutUseAdManager({ noAds }: Props) {
  useAdManager(noAds);

  return null;
}
